import React, { useState } from 'react';
import { Menu, MenuItem, Sidebar, SubMenu } from 'react-pro-sidebar';
import { useLocation } from 'react-router-dom';
import Header from '../../../components/Header/Header';
import { Box } from '@mui/material';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import ManageUsers from './User Managment/Manage Users/ManageUsers';
import RailCalendar from './Rail Calendar/RailCalendar';
import CreateWorker from './User Managment/Create New Worker/CreateWorker';
import { faBars, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdminDashboard from './Dashboard/Dashboard';
import styles from "./Dashboard.module.css"
import FRIButton from './User Managment/FRI/FRIButton';
import PasswordRecovery from './User Managment/PasswordRecovery/PasswordRecovery';
import Duplicates from './User Managment/Duplicates/Duplicates';

const Dashboard = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [menuClicked, setMenuClicked] = useState('Dashboard');

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const menuItemStyle = {
    color: '#333',
    fontWeight: 500,
  };

  return (
    <>
      {!location.pathname.includes('/resourcing') && <Header />}
      <div className={styles.layout}>
        <Sidebar collapsed={collapsed} backgroundColor='white' style={{height: '100%'}}>
          <Menu>
            <MenuItem
              style={menuItemStyle}
              onClick={toggleSidebar}
              icon={<FontAwesomeIcon icon={faBars} size='lg' />}
            />
            <MenuItem
              style={menuItemStyle}
              onClick={() => setMenuClicked('Dashboard')}
              icon={<GridViewRoundedIcon sx={{fontSize: 25}} />}
            >
              Dashboard
            </MenuItem>
            <MenuItem
              style={menuItemStyle}
              onClick={() => setMenuClicked('RailCalendar')}
              icon={<FontAwesomeIcon icon={faCalendarDays} style={{fontSize: 22}} />}
            >
              Rail Calendar
            </MenuItem>
            <SubMenu
              label="User Management"
              style={menuItemStyle}
              icon={<ManageAccountsRoundedIcon sx={{fontSize: 25}} />}
            >
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('ManageUsers')}
              >
                Manage Users
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('CreateWorker')}
              >
                Create New User
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('FRI')}
              >
                FRI Admin Panel
              </MenuItem>
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('Duplicates')}
              >
                Duplicates
              </MenuItem>
              {/* <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('IdenType')}
              >
                Identification Type
              </MenuItem> */}
              <MenuItem
                style={{ marginLeft: 25, ...menuItemStyle }}
                onClick={() => setMenuClicked('passwordRecovery')}
              >
                Password Recovery
              </MenuItem>
            </SubMenu>
          </Menu>
        </Sidebar>
        {menuClicked === 'Dashboard' &&
          <AdminDashboard />  
        }
        {menuClicked === 'ManageUsers' &&
          <Box width={"100%"} bgcolor={'white'}>
            <ManageUsers />
          </Box>
        }
        {menuClicked === 'RailCalendar' &&
          <Box width={"100%"} bgcolor={'white'}>
            <RailCalendar />
          </Box>
        }
        {menuClicked === 'CreateWorker' &&
          <Box width={"100%"} bgcolor={'white'}>
            <CreateWorker menuClicked={menuClicked} setMenuClicked={setMenuClicked} />
          </Box>
        }
        {menuClicked === 'FRI' &&
          <Box width={"100%"} bgcolor={'white'}>
            <FRIButton />
          </Box>
        }
        {menuClicked === 'Duplicates' &&
          <Box width={"100%"} bgcolor={'white'}>
            <Duplicates />
          </Box>
        }
        {menuClicked === 'passwordRecovery' &&
          <Box width={"100%"} bgcolor={'white'}>
            <PasswordRecovery />
          </Box>
        }
        {/* {menuClicked === 'IdenType' &&
          <Box width={"100%"} bgcolor={'white'}>
            <IdentificationType />
          </Box>
        } */}
      </div>
    </>
  );
};

export default Dashboard;
